<div class="training-eligibility-results ontario-small-12 ontario-medium-12 ontario-large-12"
  [class.failure]="!checkEligibility?.IsEligible">
  <div class="box-header" [class.failure]="!checkEligibility?.IsEligible">

    <!-- <img class="face-icon green-check" /> -->
    @if (checkEligibility?.IsEligible) {
      <!-- <div id="success-title-icon" style="display: inline;"></div> -->
      <div id="success-title" style="display: inline;">{{'TrainingEligibility.Results.Success' | translate}}</div>
    }

    @if (!checkEligibility?.IsEligible) {
      <div id="failure-title-icon" style="display: inline;"></div>
      <div id="failure-title" style="display: inline;">{{'TrainingEligibility.Results.NotEligible' | translate}}</div>
    }

    <div id="checked-on" style="display: inline; float: right;">{{'TrainingEligibility.Results.Checkedon' | translate}}
    {{today | utcToLocalDateTime:'MMM d, yyyy' }}</div>

  </div>

  <div class="result-card">
    <div class="first-box ontario-small-12 ontario-medium-12 ontario-large-4">
      <div>
        @if (identificationOption === 'id') {
          <div style="text-align: left;">
            <label> {{'General.MLITSD' | translate}} {{'TrainingEligibility.LearnerId' | translate}}</label>
            <b>{{trainingEligibilityForm.learnerID}}</b>
          </div>
        }
        @if (identificationOption === 'name') {
          <div style="text-align: left;">
            <label> {{'General.MLITSD' | translate}} {{'TrainingEligibility.Name' | translate}}</label>
            <b>{{trainingEligibilityForm.learnerName}}</b>
          </div>
        }
      </div>
      <br>
        <div>
          @if (contactOption === 'email') {
            <div style="text-align: left;">
              <label>{{'Contact.Email' | translate}}</label>
              <b>{{trainingEligibilityForm.emailID}}</b>
            </div>
          }
          @if (contactOption === 'phone') {
            <div style="text-align: left;">
              <label>{{'Contact.PhoneNumber' | translate}}</label>
              <b>{{trainingEligibilityForm.phoneNo | mask: '000-000-0000'}}</b>
            </div>
          }
          @if (contactOption === 'postal') {
            <div style="text-align: left;">
              <label>{{'Address.PostalCode' | translate}}</label>
              <b>{{trainingEligibilityForm.postalCode}}</b>
            </div>
          }
        </div>
      </div>

      <div class="last-box ontario-small-12 ontario-medium-12 ontario-large-8">
        <div>
          @if (checkEligibility?.IsEligible) {
            <label id="completed">{{'TrainingEligibility.Results.ByCompleting' |
              translate}} <b>{{currentLang =='en'? checkEligibility?.PrerequisiteTrainingName : checkEligibility?.PrerequisiteTrainingNameFr}}</b>
              {{'TrainingEligibility.Results.On' | translate}}
              {{checkEligibility?.EligibilityDate | utcToLocalDateTime:'MMM d, yyyy'}}
              {{'TrainingEligibility.Results.EligibleFor' |
              translate}}
              <b>{{currentLang == 'en' ? checkEligibility?.RequestedTrainingName : checkEligibility?.RequestedTrainingNameFr}}</b>
              @if (!checkEligibility?.AltOptionExists) {
                .
              }
              @if (checkEligibility?.AltOptionExists) {
                <span [innerHTML]="'TrainingEligibility.Results.AltOptionExists' | translate"></span>
              }
            </label>
          }

          @if (!checkEligibility?.IsEligible) {
            <label id="not-completed">
              {{'TrainingEligibility.Results.YourRecordsShow' | translate}}<br>
              {{'TrainingEligibility.Results.ByCompleting' | translate }} <b>{{currentLang == 'en' ? checkEligibility?.RequestedTrainingName : checkEligibility?.RequestedTrainingNameFr}}</b> {{'TrainingEligibility.Results.On' | translate}}
              {{ trainingEligibilityForm.eligibilityDate | date:"MMM d, yyyy" }} {{'TrainingEligibility.Results.YouWillNotBeEligible' | translate}}
              <b>{{currentLang == 'en' ? checkEligibility?.CertificationName : checkEligibility?.CertificationNameFr}}.</b>
            </label>
          }

          <label>{{'TrainingEligibility.Results.FurtherInformation' | translate}} <a
            [href]="currentLang == 'en' ? checkEligibility?.Link : checkEligibility?.LinkFr"
          target="_blank">{{'TrainingEligibility.Results.TrainingRequirements' | translate}}</a>
        {{'TrainingEligibility.Results.Page' | translate}}.</label>
      </div>
    </div>
  </div>
</div>